var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"mirIframe",staticStyle:{"display":"block","border":"1px solid rgb(202, 202, 202)","width":"100%","height":"100%"},attrs:{"id":"mirIframe","src":_vm.iFrameLink}})}
var staticRenderFns = []

export { render, staticRenderFns }